import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import FormControl from '@material-ui/core/FormControl'
import Typography from '@material-ui/core/Typography'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

export const registrationCloseDates = [
  {
    hoursBefore: 0,
    label: 'When the event starts',
  },
  {
    hoursBefore: 1,
    label: '1 hour before event',
  },
  {
    hoursBefore: 6,
    label: '6 hours before event',
  },
  {
    hoursBefore: 24,
    label: '1 day before event',
  },
  {
    hoursBefore: 168,
    label: '1 week before event',
  },
]

export const RegistrationCloseDateStep = () => {
  const { control, errors } = useFormContext()
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          When should registration close?
        </Typography>
      </Box>
      <Container maxWidth="xs">
        <FormControl
          error={!!errors.hoursBeforeRegistrationCloses}
          variant="outlined"
          fullWidth
        >
          <InputLabel>Select an option</InputLabel>
          <Controller
            name="hoursBeforeRegistrationCloses"
            control={control}
            as={
              <Select
                labelId="hoursBeforeRegistrationCloses"
                label="Select option"
                data-cy={'hoursBeforeRegistrationCloses'}
              >
                {registrationCloseDates.map(({ hoursBefore, label }) => (
                  <MenuItem key={label} value={hoursBefore}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            }
          />
          {errors.hoursBeforeRegistrationCloses ? (
            <Typography variant="caption" color="error">
              Please select an option
            </Typography>
          ) : null}
        </FormControl>
      </Container>
    </Box>
  )
}
